module.exports = __webpack_public_path__ + "img/paymentbg.332dddac.png";